import dayjs from 'dayjs'

export default class Daily {

  public date: string // 4/1~ の形式

  constructor(
      date: Date,
      public value: number | null,
      ) {
    this.date = dayjs(date).format('M/D')
  }
}
